export default __webpack_public_path__ + "static/media/hero-banner.9b5544c2.jpg";